import { Card, Form, Offcanvas } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import { act, useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { DashSquareFill, PlusSquareFill } from "react-bootstrap-icons";
import ReactQuill from "react-quill-new";
import WebService from "../../utility/WebService";
import { toast } from "react-toastify";
import { quillImageHandler } from "../../utility/quilImageHandler";
import CommonQuill from "../../components/editor/CommonQuill";
import HelperService from "../../utility/HelperService";

interface AddIndiaGreenHydrogenProps {
  show: boolean;
  handleClose: () => void;
  data?: any;
}

type FormData = {
  title: string;
  subTitle: string;
  slug: string;
  createdBy: string;
  meta_description: string;
  keywords: string;
};

const AddIndiaGreenHydrogen = ({
  show,
  handleClose,
  data,
}: AddIndiaGreenHydrogenProps) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
    trigger,
  } = useForm<FormData>();
  const [isLoading, setLoading] = useState(false);
  const [logo, setLogo] = useState<File | null>(null);
  const [value, setValue] = useState("");
  const [fileError, setFileError] = useState<string>("");
  const [ighcAreas, setIghcAreas] = useState([{ title: "", logo: "" }]);
  const quillRef = useRef<any>(null);
  const [customErrors, setCustomErrors] = useState<{
    description?: string;
  }>({});
  useEffect(() => {
    if (data) {
      const storedUser = localStorage.getItem("UserData");
      const userData = storedUser ? JSON.parse(storedUser) : null;
      reset({
        title: data.title,
        slug: data.slug,
        keywords: data?.keywords,
        createdBy: userData?.fullName || "",
        meta_description: data?.meta_description,
      });
      setLogo(null);
      setValue(data.description);
      setIghcAreas(
        data.ighc?.length > 0 ? data.ighc : [{ title: "", logo: null }],
      );
    }
  }, [data, show]);
  const ALLOWED_IMAGE_TYPES = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/svg+xml",
  ];
  const isQuillEmpty = (value?: string) => {
    if (!value) return true;

    // remove html tags, &nbsp; and spaces
    const text = value
      .replace(/<(.|\n)*?>/g, "")
      .replace(/&nbsp;/g, "")
      .trim();

    return text.length === 0;
  };
  const validateInfoTab = async () => {
    const titleValid = await trigger(["title"]);

    const newErrors: any = {};

    if (isQuillEmpty(value)) {
      newErrors.description = "Description is required";
    }

    setCustomErrors(newErrors);

    // 🔥 IMPORTANT: return actual validity
    return titleValid && !newErrors.description;
  };
  const onSubmit = async (request: FormData) => {
    const valid = await validateInfoTab();
    if (!valid) {
      toast.error("Please fill required fields");
      return;
    }
    setLoading(true);
    const formData = new FormData();
    const storedUser = localStorage.getItem("UserData");
    const userData = storedUser ? JSON.parse(storedUser) : null;
    formData.append("title", request.title);
    formData.append("slug", request.slug);
    formData.append("type", "INDIA_GREEN");

    const editor = quillRef.current?.getEditor();
    const html = editor?.root.innerHTML || "";
    formData.append("description", html);
    formData.append("meta_description", request.meta_description);
    formData.append("keywords", request.keywords);
    if (logo) {
      formData.append("logo", logo);
    }
    if (data?._id) {
      formData.append("id", data._id);
    }
    if (!data?._id && userData?._id) {
      formData.append("createdBy", userData._id);
    }

    // if (
    //   ighcAreas.length > 0 &&
    //   ighcAreas.every(
    //     (item) => item.title && item.logo && Object.keys(item).length !== 0,
    //   )
    // ) {
    //   formData.append("ighc", JSON.stringify(ighcAreas));
    // }

    const validIghcAreas = ighcAreas.filter(
     (b) => b.title && b.logo
    );
    formData.append("ighc", JSON.stringify(validIghcAreas));
    // ------------------------------------
    // API CALL
    // ------------------------------------
    WebService.fileUploadAPI({
      action: `council/addContent`,
      body: formData,
    })
      .then((res: any) => {
        toast.success(res.message);
        setLoading(false);
        handleClose();
      })
      .catch((err: any) => {
        setLoading(false);
        toast.error(err.response?.data?.message || "An error occurred");
      });
  };

  // IMAGES UPLOAD
  const uploadFile = (file: File, index: number) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("storage", "COUNCIL");
    WebService.fileUploadAPI({
      action: `upload`,
      body: formData,
    })
      .then((res: any) => {
        if (res.data) {
          ighcAreas[index].logo = res.data?.url;
          setIghcAreas([...ighcAreas]);
        }

        toast.success(res.message);
      })
      .catch((err: any) => {
        toast.error(err.response?.data?.message || "An error occurred");
      });
  };

  return (
    <>
      <Offcanvas
        show={show}
        onHide={() => {
          handleClose();
        }}
        placement="end"
        className="offcanvas-custom"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{data ? "Edit" : "Add"}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form>
            <Card className="p-3 bg-light my-3 position-relative">
              <span
                className="bg-white position-absolute rounded small"
                style={{ top: "-12px", left: "12px", padding: "0 8px" }}
              >
                Main Content
              </span>

              <Form.Group className="mb-2" controlId="title">
                <Form.Label className="label">Title<span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter title"
                  {...register("title", { required: "Title is required" })}
                />
                {errors.title && (
                  <div className="error-message">{errors.title.message}</div>
                )}
              </Form.Group>
              <Form.Group className="mb-2" controlId="slugField">
                <Form.Label className="label">Slug</Form.Label>{" "}
                <span className="text-danger">*</span>
                <Form.Control
                  type="text"
                  placeholder="Auto-generated slug"
                  {...register("slug", {
    required: "Slug is required",
    // pattern: {
    //   value: /^[a-z0-9-]+$/,
    //   message:
    //     "Slug must be lowercase and can only contain letters, numbers, and hyphens",
    // },
  })}
                />
                 {errors.slug && (
  <div className="error-message">{errors.slug.message}</div>
)}
              </Form.Group>
              <Form.Group className="mb-2" controlId="eventDescription">
                <Form.Label className="label">Description<span className="text-danger">*</span></Form.Label>
           
                <CommonQuill
                  ref={quillRef}
                  value={value}
                  onChange={setValue}
                  storage="COUNCIL"
                  initialHtml={show && data?.description ? HelperService.normalizeResizeHtml(data.description) : undefined}
                  onClearError={() =>
                    setCustomErrors((p) => ({
                      ...p,
                      description: undefined,
                    }))
                  }
                />
                {customErrors.description && (
                  <div className="error-message">
                    {customErrors.description}
                  </div>
                )}
              </Form.Group>
              {/* <Form.Group className="mb-2" controlId="createdBy">
                <Form.Label className="label">Created By</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Created by user"
                  {...register("createdBy")}
                  value={watch("createdBy") || ""}
                  disabled
                />
              </Form.Group> */}
            </Card>
            <Card className="p-3 bg-light my-3 position-relative">
              <span
                className="bg-white position-absolute rounded small"
                style={{ top: "-12px", left: "12px", padding: "0 8px" }}
              >
                Why IGHC?
              </span>
              <Form.Group className="mb-3">
                <Form.Label className="label"> Why IGHC?</Form.Label>
                <p
                  className="text-primary mt-1"
                  style={{ fontSize: "13px" }}
                >
                  Note: Please upload an image of size:{" "}
                  <strong>44 × 44 px</strong> in{" "}
                  <strong>.png, .jpeg, .jpg or .svg</strong> format.
                </p>
                {ighcAreas.map((item, index) => (
                  <div
                    key={index}
                    draggable
                    onDragStart={(e) =>
                      e.dataTransfer.setData("trustIndex", index.toString())
                    }
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={(e) => {
                      const fromIndex = Number(
                        e.dataTransfer.getData("trustIndex"),
                      );
                      if (fromIndex === index) return;

                      const updated = [...ighcAreas];
                      const [moved] = updated.splice(fromIndex, 1);
                      updated.splice(index, 0, moved);
                      setIghcAreas(updated);
                    }}
                  >
                    <div className="d-flex align-items-start mb-2">
                      <span className="drag-icon mx-2 my-2">⋮⋮</span>
                      <div style={{ flex: 1 }} className="highlight-item">
                        <div className="flex-1 w-100">
                          <Form.Control
                            type="file"
                            accept="image/*"
                            onChange={(e) => {
                              const input = e.target as HTMLInputElement;
                              const file = input.files?.[0];

                              if (!file) return;

                              if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
                                const msg =
                                  "Image format not supported. Please upload PNG, JPG, JPEG or SVG image.";

                                setFileError(msg);
                                toast.error(msg);
                                input.value = "";
                                return;
                              }

                              if (file) {
                                uploadFile(file, index);
                              }
                              setFileError("");
                            }}
                          />

                          {item.logo && (
                            <img
                              src={item.logo}
                              style={{ maxHeight: 120, marginTop: 5 }}
                            />
                          )}

                          <div className="d-flex mt-2">
                            <Form.Control
                              placeholder="Title"
                              value={item.title}
                              onChange={(e) => {
                                const updated = [...ighcAreas];
                                updated[index].title = e.target.value;
                                setIghcAreas(updated);
                              }}
                            />

                            <PlusSquareFill
                              className="ms-2 cursor-pointer"
                              onClick={() =>
                                setIghcAreas([
                                  ...ighcAreas,
                                  { title: "", logo: "" },
                                ])
                              }
                            />

                            {ighcAreas.length > 1 && (
                              <DashSquareFill
                                className="ms-2 cursor-pointer"
                                onClick={() =>
                                  setIghcAreas(
                                    ighcAreas.filter((_, i) => i !== index),
                                  )
                                }
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </Form.Group>
            </Card>
            <Card className="p-3 bg-light my-3 position-relative">
              <span
                className="bg-white position-absolute rounded small"
                style={{ top: "-12px", left: "12px", padding: "0 8px" }}
              >
                Media
              </span>
              <Form.Group className="mb-2" controlId="logo">
                <p
                  className="text-primary mt-1"
                  style={{ fontSize: "13px" }}
                >
                  Note: Please upload an image of size:{" "}
                  <strong>234 × 94 px</strong> in{" "}
                  <strong>.png, .jpeg, .jpg or .svg</strong> format.
                </p>
                <Form.Label className="label">Logo</Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*"
                  className="custom-image-upload"
                  onChange={(e) => {
                    const input = e.target as HTMLInputElement;
                    const file = input.files && input.files[0];
                    if (file) {
                      setLogo(file);
                    }
                  }}
                />
              </Form.Group>
              {(logo || data?.logo) && (
                <div className="mb-2 event-image">
                  <img
                    src={logo ? URL.createObjectURL(logo) : data?.logo}
                    alt="Event"
                    style={{
                      maxWidth: "100%",
                      maxHeight: 200,
                      objectFit: "contain",
                    }}
                  />
                </div>
              )}
            </Card>
            <Card className="p-3 bg-light my-3 position-relative">
              <span
                className="bg-white position-absolute rounded small"
                style={{ top: "-12px", left: "12px", padding: "0 8px" }}
              >
                SEO
              </span>
              <Form.Label className="label">
                Meta Description
                <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                as="textarea"
                placeholder="Meta Description"
                {...register("meta_description", {
                  required: "Meta description is required",
                })}
              />
              {errors.meta_description && (
                <div className="error-message">
                  {errors.meta_description.message}
                </div>
              )}
              <Form.Group className="mb-2" controlId="eventName">
                <Form.Label className="label">
                  Keywords <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter keywords"
                  {...register("keywords", {
                    required: "Keywords are required",
                  })}
                />
                {errors.keywords && (
                  <div className="error-message">{errors.keywords.message}</div>
                )}
              </Form.Group>
            </Card>
          </Form>
        </Offcanvas.Body>
        <div className="d-flex justify-content-end p-3">
          <CustomButton
            isLoading={isLoading}
            label="Save"
            className="w-100"
            onClick={handleSubmit(onSubmit)}
          />
        </div>
      </Offcanvas>
    </>
  );
};

export default AddIndiaGreenHydrogen;
